import type { CSSProperties } from "react";

export function Meter({ pct, tone }: { pct: number; tone?: string }) {
  const clamped = Math.min(100, Math.max(0, pct));
  const style = { "--w": `${clamped}%`, ...(tone ? { "--tone": tone } : {}) } as CSSProperties;
  return (
    <div className="bar">
      <i style={style} />
    </div>
  );
}
